/*
 * @Descripttion:
 * @Author: voanit
 * @Date: 2020-11-11 16:51:42
 * @LastEditors: voanit
 * @LastEditTime: 2022-11-29 10:55:18
 */

import router from './router'
import { appUser } from '@/utils'
import service from '@/api/modules/user'
import initSa from '@/utils/common/shence'
let userInfo = null

router.beforeEach(async (to, from, next) => {
  console.log(appUser, ';;;;;;;;')
  if (appUser.token && appUser.userId) {
    if (!userInfo) {
      service.getUserDetail().then(res => {
        console.log(res)
        if (appUser.miniProgram) {
          appUser.mobileNumber = res.mobileNo
          appUser.nickName = res.nickName
          appUser.avtarUrl = res.userAvtarUrl
        }
        userInfo = res
        let data = {
          level: res.userTags.level, //当前等级
          level_history: res.userTags.levelHistory, //历史最高等级
          ty_end_date: res.userTags.tyEndDate, //体验营到期时间
          wk_end_date: res.userTags.wkEndDate, //外刊到期时间
          ct_end_date: res.userTags.ctEndDate, //畅听到期时间
          svip_amount: res.userTags.svipAmount, //无限卡抵扣金额
          camp_buy_cnt: res.userTags.campBuyCnt, //体验营购买次数
          VIP_type: res.userTags.vipType, //VIP等级
          portrait_id: res.userTags.portraitId
        }
        initSa(false, data)
      })
    }
  } else {
    initSa()
  }
  next()
})
